export { default as WLSlider } from "./Slider.vue";
export * from "./types";
